import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Chat-owned confirmation dialog — SPEC-2026-09-internal-chat-pwa (ADR-005).
 *
 * Same Hyper modal markup as the product's `ConfirmationComponent`, owned by the chat
 * entry point so the standalone chat app does not have to load the product's shared
 * module to ask "are you sure?". Data is the already-translated question; closes with
 * `true` on confirm and `undefined` otherwise.
 */
@Component({
  selector: 'chat-confirm-dialog',
  templateUrl: './chat-confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatConfirmDialogComponent {

  constructor(
    public readonly dialogRef: MatDialogRef<ChatConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public readonly message: string,
  ) { }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
